import React, { PureComponent } from 'react'
import {
  Link,
} from 'react-router-dom'
import data from '../../data'

const DoctorList = ({ doctors }) => {
  console.log('DoctorList.doctors', doctors)
  
  return (
    <div className="biography-doctor-list">
      <div className="container">
        <h1>
          Doctor list
        </h1>
        <ol>
        {
          Object.keys(doctors).map((doctorId, key) => {
            const doctor = doctors[doctorId]
            
            return (
              <li key={key}>
                <Link to={`/biography/${doctorId}`}>
                  {doctor.name}
                </Link>
              </li>
            )
          })
        }
        </ol>
      </div>
    </div>
  )
}

const DoctorBiography = ({ doctor }) => {
  console.log('DoctorBiography.doctor', doctor)
  
  return (
    <div className="biography-doctor">
      <div className="container">
        {doctor.name}'s biography
      </div>
    </div>
  )
}

const Biography = ({ data, match }) => {
  if (match && match.params.doctorId !== undefined && data.doctors[match.params.doctorId] !== undefined) {
    return <DoctorBiography doctor={data.doctors[match.params.doctorId]} />
  } else {
    return <DoctorList doctors={data.doctors} />
  }
}

export default Biography



// WEBPACK FOOTER //
// ./src/components/Biography/index.js